/* Kernmodul des Mapeditors: reine Logik ohne DOM. Fasst Modell, Parser und Schreiber unter dem bekannten Namen Core zusammen.
 * Brush = { id, verts: [[x,y,z]], faces: [{ vi:[...], tex, ua, uo, va, vo, rot, xs, ys }], srcText? }
 * Die Flächen-Schleifen vi laufen von außen gesehen gegen den Uhrzeigersinn.
 * Ebenen entstehen erst beim Schreiben aus den Eckpunkten.
 *   model/     Typen, Vektoren, IDs, Brushes, Dokument und Verlauf, Prüfungen
 *   formats/   Parser und Schreiber für .map */
import { add, cross, dot, len, mirrorMat, mul, norm, parseVec, rotMat, sub } from './model/vec.ts';
import { bumpId, dedupeIds, newId, validId } from './model/ids.ts';
import { bbox, bboxOf, buildHull, clipBrush, defaultAxes, defaultFace, faceNormal, makeBrush, mirrorAround, moveVertices, rebuildBrush, rotateAround, scaleBrush, transformBrush, translateBrush } from './model/brush.ts';
import { addBrushes, addEntity, allBrushes, emptyDoc, entityOfBrush, findBrush, History, mapBrushes, moveBrushesToEntity, newWorld, updateEntity } from './model/doc.ts';
import { complexityItems, isSpecialTex, mapKind, SPECIAL, validate, worstLevel } from './model/check.ts';
import { parseText } from './formats/map-parse.ts';
import { brushText, faceLine, planePoints, toText } from './formats/map-write.ts';

const Core = {
  mapKind, sub, add, mul, dot, cross, len, norm, newId, bumpId, validId, dedupeIds,
  defaultAxes, defaultFace, faceNormal, buildHull, makeBrush, rebuildBrush, bbox, bboxOf,
  rotMat, mirrorMat, transformBrush, translateBrush, rotateAround, mirrorAround, scaleBrush, moveVertices, clipBrush,
  parseText, toText, brushText, faceLine, planePoints, emptyDoc, newWorld, parseVec,
  allBrushes, findBrush, mapBrushes, addBrushes, addEntity, updateEntity, moveBrushesToEntity, entityOfBrush,
  History, validate, worstLevel, complexityItems, isSpecialTex, SPECIAL
};
export default Core;
export type { Brush, Doc, Entity, Face, Vec3, Mat3, BBox, CheckItem, ParseResult, MapKind } from './model/types.ts';
